import { FilterType } from 'components/Shared/Table'
import userRolesOptions from 'constants/userRolesOptions'

export const columns = [
  {
    id: 'firstName',
    label: 'userTable.firstName',
    path: 'firstName',
    sortable: true,
    filterType: FilterType.Text
  },
  {
    id: 'lastName',
    label: 'userTable.lastName',
    path: 'lastName',
    sortable: true,
    filterType: FilterType.Text
  },
  {
    id: 'roles',
    label: 'userTable.role.title',
    path: 'role',
    filterType: FilterType.Select,
    selectOptions: userRolesOptions
  },
  {
    id: 'phoneNumber',
    label: 'userTable.phoneNumber',
    path: 'phoneNumber',
    filterType: FilterType.Text
  },
  {
    id: 'personalPhoneNumber',
    label: 'userTable.personalPhoneNumber',
    path: 'personalPhoneNumber',
    filterType: FilterType.Text
  },
  {
    id: 'email',
    label: 'userTable.email',
    path: 'email',
    filterType: FilterType.Text
  }
]
